module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recordInfo"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("楼宇名称")]), _vm._v(" "), _c('td', {
    staticClass: "tbContent",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.buildingInfos.buildingName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("物业单位")]), _vm._v(" "), _c('td', {
    staticClass: "tbContent"
  }, [_vm._v(_vm._s(_vm.buildingInfos.tenement))]), _vm._v(" "), _c('td', {
    staticClass: "tbName"
  }, [_vm._v("产权单位")]), _vm._v(" "), _c('td', {
    staticClass: "tbContent"
  }, [_vm._v(_vm._s(_vm.buildingInfos.propertyUnit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("所在街乡")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.jiexiang))]), _vm._v(" "), _c('td', {
    staticClass: "tbName"
  }, [_vm._v("地址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.address))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("所属功能区")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.park))]), _vm._v(" "), _c('td', {
    staticClass: "tbName"
  }, [_vm._v("项目类型")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.projectType))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("是否国有")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.nationalized))]), _vm._v(" "), _c('td', {
    staticClass: "tbName"
  }, [_vm._v("产业定位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.location))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("是否愿意在市级平台对外发布推介")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.isWillingCityPlatformReleaseRecommend))]), _vm._v(" "), _c('td', {
    staticClass: "tbName"
  }, [_vm._v("是否愿意在区级招商工作中对外发布推介")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.isWillingDistrictInvestmentWorkeleaseRecommend))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("不希望对外发布的原因")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.notPublishReason))]), _vm._v(" "), _c('td', {
    staticClass: "tbName"
  }, [_vm._v("是否愿意承接国际组织办公场所")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.isWillingUndertakeInterOrganizationWorkspace))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("规划建筑面积(平方米)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.planBuildingArea) + "㎡")]), _vm._v(" "), _c('td', {
    staticClass: "tbName"
  }, [_vm._v("当前空置可招商面积")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.totalVacantArea) + "㎡")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("招商负责人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.leadingCadre))]), _vm._v(" "), _c('td', {
    staticClass: "tbName"
  }, [_vm._v("负责人手机号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.leadingCadrePhone))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("负责人邮箱")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.leadingCadreEmail))]), _vm._v(" "), _c('td', {
    staticClass: "tbName"
  }, [_vm._v("周边交通情况")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.trafficCondition))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbName"
  }, [_vm._v("周边公共配套情况")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buildingInfos.supportingSituation))]), _vm._v(" "), _c('td', {
    staticClass: "tbName"
  }, [_vm._v("其他补充说明")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.buildingInfos.other))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-cfd43ece"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingInfos/components/recordBuilding.vue
// module id = 1562
// module chunks = 1